import React, { useState, useEffect, useRef } from "react"
import { ContactForm, Eyebrow, Headline, CloseButton } from "@shared"
import { logTool, css, useSassUnitValues, listenDocEvent, focusTools, keyboard } from "@jsUtils"
import { CONSTANTS, CONTENT } from "@data"

import Styles from "./demoForm.module.scss"

const { keyId } = keyboard
const { scopeTab } = focusTools

const { EXO_DEMO_FORM } = CONTENT
const { title, lead, header, completeContent } = EXO_DEMO_FORM

const { EVENTS, COLORS, GRADIENTS, BREAKPOINTS } = CONSTANTS
const { KEYEVENT, RESIZE } = EVENTS
const MOBILE_BREAKPOINT = useSassUnitValues(BREAKPOINTS.MOBILE)

const log = logTool()

const objs = {
  demoContent: "demo-form-content"
}

/**
 * Demo overlay form
 * @param {object} props - react props
 */
const DemoFormContent = props => {
  const { openState: open, openClose } = props

  const mainFormWrap = useRef(false)
  const [success, setSuccess] = useState(false)
  const [mobileLayout, setMobileLayout] = useState(false)

  const onDemoKeyboard = e => {
    let keyPress = false
    keyPress = keyId(e)
    if (keyPress.escape) {
      openClose()
    }
    if (keyPress.tab) {
      log("tabbing...")
      scopeTab({
        node: mainFormWrap.current,
        event: e
      })
    }
  }

  const onClose = e => {
    e.preventDefault()
    e.target.blur()
    openClose()
  }

  const onResize = () => {
    if (window.innerWidth < MOBILE_BREAKPOINT && !mobileLayout) {
      setMobileLayout(true)
    } else if (window.innerWidth >= MOBILE_BREAKPOINT && mobileLayout) {
      setMobileLayout(false)
    }
  }

  useEffect(() => {
    log("DemoFormContent init")
    if (open) {
      onResize()
      listenDocEvent(RESIZE, onResize)
      listenDocEvent(KEYEVENT, onDemoKeyboard)
    }
    return () => {
      log("DemoFormContent unload")
      setSuccess(false)
      listenDocEvent(RESIZE, onResize, false)
      listenDocEvent(KEYEVENT, onDemoKeyboard, false)
    }
  }, [open])

  const tabbing = open ? 0 : -1

  return (
    <div ref={mainFormWrap} className={css(Styles.formContent, open && Styles.formOpen)}>
      <div className={Styles.header}>
        <CloseButton tabbing={tabbing} onClose={onClose} ariaExpanded ariaLabel="Close" />
      </div>
      <div className={Styles.body} id={objs.demoContent}>
        {open && !success && (
          <div className={Styles.intro}>
            <Headline size={1} className={Styles.introTitle}>
              {title}
            </Headline>
            <Headline size={2} className={Styles.introText}>
              See why industry experts are buzzing about Exo Works
              <sup className={Styles.tradeMark}>TM</sup>, our POCUS workflow solution. Sign up and
              get a tour today.
            </Headline>
            {/* <h2 className={Styles.introText}>Get a glimpse of Exo Works’ capabilities</h2> */}
            <ul className={Styles.checklist}>
              <li>See what fast documentation and QA can do for you</li>
              <li>Learn why having a superior workflow matters</li>
              <li>Ask about pricing and estimate your ROI</li>
            </ul>
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <video className={Styles.video} controls width="400" preload="metadata">
              <source
                src="https://exo-inc-videos.s3.us-west-1.amazonaws.com/Experience+the+Freedom+of+Exo+Works.mp4#t=0.5"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
        )}
        {open && !success && (
          <div className={Styles.contactForm}>
            <Eyebrow className={Styles.eyebrow} color={COLORS.FLURO}>
              {header}
            </Eyebrow>
            <ContactForm
              id="demo-form-content-module"
              captchaMsg
              portalId="20465501"
              formId="c74c58f6-1916-457a-8dc7-33d770d326f4"
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default DemoFormContent
